export default __webpack_public_path__ + "static/media/075-mail.f94deb23.svg";